<template>
  <div class="message-pop message-box" v-show="isBoxShow">
    <div class="message-pop-wrapper">
      <div class="pop-header clearfix">
        <p class="fl">与 <span class="uname" v-if="from_to[uid]">{{from_to[uid].nick_name}}</span> 的对话</p>
        <a href="javascript:;"  class="fr s-popup-close" @click="closeBox">
          <span><img src="../../../images/common/close.png" alt=""></span>
        </a>
      </div>

      <div class="pop-body">
        <div v-show="page.curPage<page.totalPage&&!isLoading" class="load-more" @click="getMsgList(parseInt(page.curPage)+1)">
          <i class="icon-clock-blue"></i>查看更多消息
        </div>
        <div v-show="page.curPage<page.totalPage&&isLoading" class="loading-box">
          <img class="loading" width="16" height="16" src="../../../images/common/loading_2_24x24.gif">加载中
        </div>
        <ul class="msg-list">
          <li class="msg-item clearfix" :class="[item.is_me?'msg-item-right':'msg-item-left','msg'+item.msg_id]" v-for="item in msgList">
            <div class="avatar-box">
              <img class="avatar" width="60" height="60" v-if="from_to[item.from_id].user_logo.indexOf('?')==0" src="../../../images/personal_center/avatar_default.png" alt="">
              <img v-else class="avatar" width="60" height="60" :src="from_to[item.from_id].user_logo" alt="">
            </div>
            <div class="content-box">
              <p class="time">{{item.create_time}}</p>
              <div class="content"><i class="corner"></i><pre v-html="item.content"></pre></div>
            </div>
          </li>
        </ul>
      </div>

      <div class="pop-footer">
        <div class="text-box">
          <textarea placeholder="在此输入回复内容" class="text" name="name" rows="8" cols="80" maxlength="200" v-model="msg.content"></textarea>
        </div>
        <div class="send">
          <span v-if="200-msg.content.length>=0">还可以输入 <span class="number">{{200 - msg.content.length}}</span> 个字符</span><span v-else>已超出 <span class="number">{{msg.content.length - 200}}</span> 个字符</span>
          <a class="send-msg" href="javascript:void(0);" @click="sendMsg" v-if="!msg.isSubmit">发送</a>
          <a class="send-msg" href="javascript:void(0);" v-else><img class="loading" src="../../../images/common/loading_16.svg" alt="">提交中</a>
        </div>
      </div>
    </div>
    <v-alert :options="options"></v-alert>
  </div>
</template>

<script type="text/javascript">
  import vAlert from "../../alert.vue";
  export default {
    props: {
      isBoxShow: {
        default: false
      },
      uid: {
        default: 0
      },
      msgItem: {
        type: Object
      }
    },
    data() {
      return {
        page: {
          curPage: 1,
          total: 0,
          totalPage: 1
        },
        msgList: [],
        from_to: {},
        msg: {
          content: '',
          isSubmit: false  //是否处于提交中
        },
        isLoading: false,  // 是否处于加载更多
        options: {}
      }
    },
    watch: {
      uid: function(newVal, oldVal) {
        if (newVal != 0) {
          this.getMsgList(1);
        }
      }
    },
    methods: {
      closeBox() {
        let msg = this.msgList[this.msgList.length - 1];
        this.msgItem.content = msg.content;
        this.msgItem.msg_cnt = this.page.total;
        this.msgItem.create_time = msg.create_time;
        this.$emit('closeBox');
      },
      sendMsg() {  // 留言
        if (this.msg.content.length<=0) {
          this.options = {
            msgIsSuccess: false,
            msgText: "请输入留言内容"
          }
          return ;
        }
        if (this.msg.content.trim() === "") {
          this.options = {
            msgIsSuccess: false,
            msgText: "输入内容不能为空"
          }
          return ;
        }
        if (this.msg.content.length>200) {
          this.options = {
            msgIsSuccess: false,
            msgText: "内容长度不合法"
          }
          return ;
        }
        this.msg.isSubmit = true;
        axios.post(myUrl + "sns/message/leave/" + this.uid + "/", qs.stringify({
          content: this.msg.content,
          mode: 'talking',
        })).then((res) => {
          res = res.data;
          if (res.result) {
            this.msg.content = "";
            this.getMsgList(1);
          }else {
            this.options = {
              msgText: "留言失败，请稍后重试",
              msgIsSuccess: false
            }
          }
          this.msg.isSubmit = false;
        }).catch(() => {
          this.msg.isSubmit = false;
        })
      },
      getMsgList(curPage) {
        if (curPage>this.page.totalPage) {
          return ;
        }
        if (curPage!=1) {
          this.isLoading = true;
        }
        axios.post(myUrl + "sns/message/from/" + this.uid + "/", qs.stringify({
          page: curPage
        })).then((res) => {
          res = res.data;
          if (res.result) {
            let elemId;
            if (curPage==1) {
              this.msgList = []
            }
            if (this.msgList[0]) {
              elemId = ".msg"+this.msgList[0].msg_id;
            }
            this.msgList = res.data.items.reverse().concat(this.msgList);
            this.from_to = res.data.from_to;
            this.page = res.data.page;

            if (elemId===undefined) {
              this.$nextTick(() => {
                // let height = 0;
                // height = $(".pop-body .mCSB_container").height() - $(".pop-body .mCustomScrollBox").height();
                // $(".pop-body .mCSB_container").css({top:-height})
                // setTimeout(() => {
                  // let draggerHeight = $(".pop-body .mCSB_draggerContainer").height() - $(".pop-body .mCSB_dragger").height();
                  // $(".pop-body .mCSB_dragger").css({top: draggerHeight})
                  $(".pop-body").mCustomScrollbar("scrollTo","bottom",{
                      scrollInertia:0
                  });
                // }, 100)
              })
            }
            console.log(elemId);
            if (elemId!=undefined) {
              let items = res.data.items;
              this.$nextTick(() => {
                let height = 0;
                for (var i = 0; i < items.length; i++) {
                  height += ($(".msg" + items[i].msg_id).height() + 20);
                }
                if (res.data.page.curPage==res.data.page.totalPage) {
                  height -= 70;
                }
                // $(".pop-body .mCSB_container").css({top:-height})
                $(".pop-body").mCustomScrollbar("scrollTo",-height,{
                    scrollInertia:0
                });
              })
            }
          }
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        })
      }
    },
    mounted() {
      $(".pop-body").mCustomScrollbar({
        theme:"minimal-dark", //设置风格
        setHeight: "calc(100% - 295px)"
      });
    },
    components: {
      vAlert
    }
  }
</script>

<style media="screen" lang="scss">
  .message-pop.message-box{
    .mCSB_scrollTools, .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar, .mCSB_scrollTools .mCSB_buttonUp, .mCSB_scrollTools .mCSB_buttonDown, .mCSB_scrollTools .mCSB_buttonLeft, .mCSB_scrollTools .mCSB_buttonRight {
      -webkit-transition: none;
      -moz-transition: none;
      -o-transition: none;
      transition: none;
    }
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1234;
    pre{
      white-space: pre-wrap;
      white-space: -moz-pre-wrap;
      white-space: -pre-wrap;
      white-space: -o-pre-wrap;
      word-break: break-word;
    }
    .message-pop-wrapper{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      width: 800px;
      min-height: 465px;
      height: 80%;
      background-color: #fff;
      transition: all linear .5s;
      border-radius: 4px;
      .pop-header{
        font-size: 14px;
        padding: 20px 30px;
        color: #a6a6a6;
        .uname{
          color: #444;
        }
      }
      .pop-body{
        border-top: 1px solid #eaeaea;
        border-bottom: 1px solid #eaeaea;
        background: #fafafa;
        padding: 24px 30px 40px;
        overflow: auto;
        .load-more{
          color: #57a3f1;
          text-align: center;
          margin-bottom: 50px;
          cursor: pointer;
          .icon-clock-blue{
            width: 16px;
            height: 16px;
            display: inline-block;
            background: url(../../../images/personal_center/icon-clock-blue.png);
            vertical-align: sub;
            margin-right: 8px;
          }
        }
        .loading-box{
          color: #666;
          text-align: center;
          margin-bottom: 50px;
          .loading{
            margin-right: 5px;
          }
        }
        .msg-list{
          .msg-item{
            margin-bottom: 20px;
            .avatar{
              border-radius: 3px;
            }
            .time{
              color: #aaaaaa;
              font-size: 12px;
            }
            .content{
              margin-top: 8px;
              padding: 14px;
              color: #666666;
              font-size: 14px;
              border-radius: 10px;
              max-width: 510px;
              position: relative;
              .corner{
                width: 12px;
                height: 12px;
                display: inline-block;
                position: absolute;
                top: 8px;
              }
            }
            &-left{
              .avatar-box{
                float: left;
                .avatar{
                  margin-right: 25px;
                }
              }
              .content-box{
                float: left;
                .content{
                  background: #e5e5ea;
                  .corner{
                    background: url(../../../images/personal_center/corner-gray.png);
                    left: -8px;
                  }
                }
              }
            }
            &-right{
              .avatar-box{
                float: right;
                .avatar{
                  margin-left: 25px;
                }
              }
              .content-box{
                float: right;
                .time{
                  text-align: right;
                }
                .content{
                  background: #57a3f1;
                  color: #fff;
                  .corner{
                    background: url(../../../images/personal_center/corner-blue.png);
                    right: -8px;
                  }
                }
              }
            }
          }
        }
      }
      .pop-footer{
        padding: 20px 30px 50px;
        .text-box{
          height: 120px;
          .text{
            border-radius: 3px;
            width: 740px;
            height: 120px;
            border: 1px solid #e5e5e5;
            resize: none;
            font-size: 12px;
            padding: 10px 12px;
          }
        }
        .send{
          margin-top: 15px;
          text-align: right;
          color: #adadb2;
          font-size: 12px;
          .number{
            color: #57a3f1;
          }
          .send-msg{
            margin-left: 10px;
            width: 90px;
            height: 30px;
            border: 1px solid #e5e5e5;
            background: #57a3f1;
            text-align: center;
            line-height: 28px;
            color: #fff;
            display: inline-block;
            .loading{
              margin-top: -2px;
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// message_box.vue?32dc89d1